import { useTranslation } from 'react-i18next';
import { WriteLyricsIcon } from '../../../../../components/Icons';

interface StationLyricsViewProps {
  title: string;
  lyrics: string;
  lyricsContentRef: React.RefObject<HTMLDivElement | null>;
  isUserEditing: boolean;
  onFocus: () => void;
  onBlur: () => void;
  onInput: () => void;
  isLoading?: boolean;
}

export const StationLyricsView = ({
  title,
  lyricsContentRef,
  onFocus,
  onBlur,
  onInput,
  isLoading = false,
}: StationLyricsViewProps) => {
  const { t } = useTranslation();
  return (
    <div
      className="relative flex flex-col w-full overflow-hidden rounded-[36px] p-4 gap-4 flex-1 self-stretch"
      style={{
        background:
          'radial-gradient(ellipse at center, #000 0%, rgba(0, 0, 0, 0.8) 50%, rgba(0, 0, 0, 0.4) 80%, transparent 100%)',
      }}>
      <div
        className="absolute inset-0 pointer-events-none rounded-[36px] p-[1.567px] z-0"
        style={{
          background:
            'linear-gradient(to bottom, #666 0%, #666 30%, rgba(102, 102, 102, 0.6) 60%, rgba(102, 102, 102, 0.2) 80%, transparent 100%)',
          mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
          WebkitMask:
            'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
          maskComposite: 'exclude',
          WebkitMaskComposite: 'xor',
        }}
      />
      <div className="relative z-10 flex flex-col w-full h-full rounded-[24px] border-[1.567px] border-white/5 bg-white/5">
        <div className="px-5 py-5 shrink-0 flex items-center gap-3">
          <div className="w-9 h-9 relative overflow-hidden">
            <WriteLyricsIcon />
          </div>
          <div className="text-white font-['DM_Sans'] text-[26px] font-medium leading-[40px] tracking-[-0.52px]">
            <span>{t('generation.writeLyrics')} </span>
            <span className="text-white/50">{t('generation.editOrTellChanges')}</span>
          </div>
        </div>

        <div className="self-stretch flex-1 min-h-0 overflow-hidden">
          <div className="relative w-full h-full overflow-auto custom-scrollbar flex flex-col items-start gap-6 flex-1 self-stretch rounded-[24px] border-[1.567px] border-white/5 bg-white/5 p-7">
            {isLoading && (
              <div className="absolute inset-0 pointer-events-none rounded-[24px] overflow-hidden z-10">
                <div
                  className="absolute inset-0 animate-glass-flow"
                  style={{
                    background:
                      'linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.4) 50%, transparent 100%)',
                    width: '200%',
                    height: '200%',
                  }}
                />
              </div>
            )}
            <>
              <div className="self-stretch text-left text-white/90 font-['Times_New_Roman'] text-[50px] font-normal leading-[38px] tracking-[-1.5px]">
                {title}
              </div>
              <div
                ref={lyricsContentRef}
                contentEditable={true}
                className="self-stretch flex-1 bg-transparent resize-none focus:outline-none text-left break-words min-h-[200px] select-text"
                onFocus={onFocus}
                onBlur={onBlur}
                onInput={onInput}
                suppressContentEditableWarning={true}
              />
            </>
          </div>
        </div>
      </div>
    </div>
  );
};
